import jp from '../services/jpService';
import { ActionTypes } from '../constants';
import { asyncAction } from "./commonActions";

export const getJobPlans = (appCode, searchString = null, skip = null, limit = null) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_JP_JOBPLAN_LIST_REQUEST,
        success: ActionTypes.GET_JP_JOBPLAN_LIST_SUCCESS,
        failure: ActionTypes.GET_JP_JOBPLAN_LIST_FAILURE
    },
    serviceAction: jp.getJobPlans,
    appCode,
    searchString,
    skip,
    limit
});

export const getJobPlanDetails = (appCode, id) => asyncAction({
    actionTypes:{
        request: ActionTypes.GET_JP_JOBPLAN_REQUEST,
        success: ActionTypes.GET_JP_JOBPLAN_SUCCESS,
        failure: ActionTypes.GET_JP_JOBPLAN_FAILURE
    },
    serviceAction: jp.getJobPlanDetails,
    appCode,
    id
});

export const deleteJobPlan = (appCode, id) => asyncAction({
    actionTypes:{
        request: ActionTypes.DELETE_JP_JOBPLAN_REQUEST,
        success: ActionTypes.DELETE_JP_JOBPLAN_SUCCESS,
        failure: ActionTypes.DELETE_JP_JOBPLAN_FAILURE
    },
    serviceAction: jp.deleteJobPlan,
    appCode,
    id
});


export const addJobPlanActivity = (appCode, jpId, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.ADD_JP_ACTIVITY_REQUEST,
        success: ActionTypes.ADD_JP_ACTIVITY_SUCCESS,
        failure: ActionTypes.ADD_JP_ACTIVITY_FAILURE
    },
    serviceAction: jp.addJobPlanActivity,
    appCode,
    jpId,
    params
});

export const updateJobPlanActivity = (appCode, id, jpId, params) => asyncAction({
    actionTypes:{
        request: ActionTypes.UPDATE_JP_ACTIVITY_REQUEST,
        success: ActionTypes.UPDATE_JP_ACTIVITY_SUCCESS,
        failure: ActionTypes.UPDATE_JP_ACTIVITY_FAILURE
    },
    serviceAction: jp.updateJobPlanActivity,
    appCode,
    id,
    jpId,
    params
});

export const deleteJobPlanActivity = (appCode, id, jpId) => asyncAction({
    actionTypes:{
        request: ActionTypes.DELETE_JP_ACTIVITY_REQUEST,
        success: ActionTypes.DELETE_JP_ACTIVITY_SUCCESS,
        failure: ActionTypes.DELETE_JP_ACTIVITY_FAILURE
    },
    serviceAction: jp.deleteJobPlanActivity,
    appCode,
    id,
    jpId
});

export const getJobPlanActivityCategories = (appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_JP_ACTIVITY_CATEGORY_LIST_REQUEST,
        success: ActionTypes.GET_JP_ACTIVITY_CATEGORY_LIST_SUCCESS,
        failure: ActionTypes.GET_JP_ACTIVITY_CATEGORY_LIST_FAILURE,
    },
    serviceAction: jp.getJobPlanActivityCategories,
    appCode
});

export const getJobPlanActivityTypes = (appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_JP_ACTIVITY_TYPE_LIST_REQUEST,
        success: ActionTypes.GET_JP_ACTIVITY_TYPE_LIST_SUCCESS,
        failure: ActionTypes.GET_JP_ACTIVITY_TYPE_LIST_FAILURE,
    },
    serviceAction: jp.getJobPlanActivityTypes,
    appCode
});

export const getJobPlanActivityLocations = (appCode) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_JP_LOCATION_LIST_REQUEST,
        success: ActionTypes.GET_JP_LOCATION_LIST_SUCCESS,
        failure: ActionTypes.GET_JP_LOCATION_LIST_FAILURE,
    },
    serviceAction: jp.getJobPlanActivityLocations,
    appCode
});

export const getJobPlanActivityObjectives = (appCode, jpId) => asyncAction({
    actionTypes: {
        request: ActionTypes.GET_JP_ACTIVITY_OBJECTIVE_LIST_REQUEST,
        success: ActionTypes.GET_JP_ACTIVITY_OBJECTIVE_LIST_SUCCESS,
        failure: ActionTypes.GET_JP_ACTIVITY_OBJECTIVE_LIST_FAILURE
    },
    serviceAction: jp.getJobPlanActivityObjectives,
    appCode,
    jpId
});

const jpActions = {
    getJobPlans,
    getJobPlanDetails,
    deleteJobPlan,
    addJobPlanActivity,
    updateJobPlanActivity,
    deleteJobPlanActivity,
    getJobPlanActivityCategories,
    getJobPlanActivityTypes,
    getJobPlanActivityLocations,
    getJobPlanActivityObjectives
};

export default jpActions;
